import { memo } from "react";
import { getContentAmount } from "@shared/functions/getContentAmount";
import { pluralForm } from "@shared/functions/pluralForm";
import styles from "@features/Course/parts/course/Content/parts/ContentAccordion/style.module.sass";
import { formatTotalTime } from "@shared/functions/formatTotalTime";
import { SectionDto } from "@generated/models/SectionDto";

type AccordionTimeProps = {
	section: SectionDto;
};

const AccordionTime = memo(({ section }: AccordionTimeProps) => {
	const lecturesAmount = getContentAmount([section], "lecture");
	const pluralLecturesAmount = pluralForm(lecturesAmount || 0, "лекция", "лекции", "лекций");

	return (
		<div className={styles.sectionTime}>
			{lecturesAmount || 0} {pluralLecturesAmount}, {formatTotalTime(section.totalDuration || 0)}
		</div>
	);
});

AccordionTime.displayName = "AccordionTime";

export default AccordionTime;
